import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { putPAJAF010UpdateMatching, getCommonInfo } from '../../services/Api';

const initialState = {
    savedPAFAA010Conditions: [],
};

export const fetchInitialConditions = createAsyncThunk(
    'PAFAA010/fetchInitialConditions',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await getCommonInfo();
            if (data.matchResume) {
                const parsed = JSON.parse(data.matchResume);
                return Array.isArray(parsed) ? parsed : [parsed];
            }
            return [];
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const saveMatchingConditions = createAsyncThunk(
    'PAFAA010/saveMatchingConditions',
    async (memberSeq, { getState, rejectWithValue }) => {
        try {
            const savedPAFAA010Conditions = getState().PAFAA010.savedPAFAA010Conditions;
            const matchingData = JSON.stringify(savedPAFAA010Conditions);
            const response = await putPAJAF010UpdateMatching({ seq: memberSeq, matching: matchingData });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const PAFAA010Slice = createSlice({
    name: 'PAFAA010Reducer',
    initialState,
    reducers: {
        saveFilterPAFAA010Conditions: (state, action) => {
            const newCondition = {
                checkedStoreValues: action.payload.checkedValues,
                checkedLikeRightStoreValues: action.payload.checkedLikeRightValues,
                startStoreDate: action.payload.startDate,
                endStoreDate: action.payload.endDate,
                savedStoreDate: action.payload.savedDate,
                checkedStoreLabels: action.payload.checkedLabels,
                resumeRegionStore: action.payload.resumeRegion,
                activeTabIndex: action.payload.activeTabIndex,
                activeTabCheckbox: action.payload.activeTabCheckbox,
            };

            state.savedPAFAA010Conditions.push(newCondition);

            if (state.savedPAFAA010Conditions.length > 5) {
                state.savedPAFAA010Conditions.shift();
            }
        },

        updateFilterPAFAA010Conditions: (state, action) => {
            const { index, updatedCondition } = action.payload;

            if (index >= 0 && index < state.savedPAFAA010Conditions.length) {
                state.savedPAFAA010Conditions[index] = {
                    ...state.savedPAFAA010Conditions[index],
                    resumeRegionStore: {
                        ...updatedCondition.resumeRegionStore,
                    },
                    ...updatedCondition,
                };
            }
        },

        deleteFilterPAFAA010Conditions: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.savedPAFAA010Conditions.length) {
                state.savedPAFAA010Conditions.splice(index, 1);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchInitialConditions.fulfilled, (state, action) => {
            state.savedPAFAA010Conditions = action.payload;
        });
        builder.addCase(saveMatchingConditions.fulfilled, (state, action) => {});
    },
});

export const { saveFilterPAFAA010Conditions, updateFilterPAFAA010Conditions, deleteFilterPAFAA010Conditions } =
    PAFAA010Slice.actions;
export default PAFAA010Slice.reducer;
